import axios from "axios";
import { ENDPOINTS } from "./ENDPOINT";

// Platform Owner only — creating/listing restaurants themselves, not any
// single restaurant's own day-to-day data.
const restaurantService = {
  listRestaurants: async () => {
    const response = await axios.get(`${ENDPOINTS.BASE}/restaurants`);
    return response.data;
  },

  createRestaurant: async (payload) => {
    const response = await axios.post(`${ENDPOINTS.BASE}/restaurants`, payload);
    return response.data;
  },

  updateRestaurant: async (id, payload) => {
    const response = await axios.put(`${ENDPOINTS.BASE}/restaurants/${id}`, payload);
    return response.data;
  },

  deleteRestaurant: async (id) => {
    const response = await axios.delete(`${ENDPOINTS.BASE}/restaurants/${id}`);
    return response.data;
  },
};

export default restaurantService;
